import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Cool thing Thursday: Leanpub",
  "description": "",
  "published": "2012-11-22T00:00:00.000Z",
  "redirect_from": ["/blog/cool-thing-thursday-leanpub/swizec/5593"],
  "categories": "Amazon Kindle, E-book, IPad, Kindle, Landing page, Leanpub, Publishing, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "https://leanpub.com/"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/11/leanpub.com_-1024x390.png",
          "alt": "leanpub.com",
          "title": "leanpub.com"
        }}></img></a></p>
    <p>{`The past few years have seen a venerable explosion of self-published `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/E-book",
        "title": "E-book"
      }}>{`ebooks`}</a>{`.`}</p>
    <p>{`Might be that e-book readers are becoming ever more popular, or that `}<em parentName="p">{`people actually buy ebooks`}</em>{`. Whatever it is, this is a good time to get your act together and write a book on something you're good at.`}</p>
    <p>{`Or even not good at. There's a guy who will research any suggested topic and write a book. Naturally, I can't find the link right now because `}<em parentName="p">{`"I will write a book about anything"`}</em>{` is a terrible search term.`}</p>
    <p>{`But what's a guy to do once a topic has been identified?`}</p>
    <p>{`Creating an ebook takes plenty of strange knowledge about file formats, layouting and making sure this book looks equally good on an `}<a parentName="p" {...{
        "href": "http://www.t-mobile.com/shop/phones/?capcode=AGE",
        "title": "Android phones"
      }}>{`Android phone`}</a>{` as it does on an `}<a parentName="p" {...{
        "href": "http://www.apple.com/ipad/",
        "title": "iPad"
      }}>{`iPad`}</a>{` or a `}<a parentName="p" {...{
        "href": "http://www.amazon.com/Kindle-Wireless-Reader-Wifi-Graphite/dp/B002Y27P3M%3FSubscriptionId%3D0G81C5DAZ03ZR9WH9X82%26tag%3Dageewitahat-20%26linkCode%3Dxm2%26camp%3D2025%26creative%3D165953%26creativeASIN%3DB002Y27P3M",
        "title": "Kindle Wireless Reading Device, Wi-Fi, 6\" Display, Graphite - Latest Generation"
      }}>{`Kindle`}</a>{`. Let's not forget the book will eventually need to be sold - you need a website, a `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Landing_page",
        "title": "Landing page"
      }}>{`landing page`}</a>{`, some marketing, optimizing conversion funnels, some way to send emails to buyers, processing payments ...`}</p>
    <p>{`Blah. All I wanted was to write a book!`}</p>
    <p>{`Plenty of services exist that help you out with everything `}<em parentName="p">{`around`}</em>{` your book, so you can focus on the writing (and marketing, self-publishing means you do the marketing). My google-fu revealed Leanpub as the best option. My experience so far tends to agree.`}</p>
    <h2 {...{
      "id": "leanpub"
    }}>{`Leanpub`}</h2>
    <p><a parentName="p" {...{
        "href": "https://leanpub.com/"
      }}>{`Leanpub`}</a>{` is an ebook self-publishing platform with an interesting twist - it encourages authors to treat their books as lean startups.`}</p>
    <p>{`The idea is to eschew all the crap that comes with writing a book for several months only to discover nobody wants to read it. Instead, you write the first nugget of a book and start selling. When you write more and the book matures, updates are pushed to all your readers for free.`}</p>
    <p>{`Essentially people are paying for a future full book, but getting a taste of it `}<em parentName="p">{`now.`}</em></p>
    <p>{`Two things happen:`}</p>
    <ol>
      <li parentName="ol">{`You get continuous feedback and can adjust the course of your book at any point. In the end you will almost certainly have an awesome book.`}</li>
      <li parentName="ol">{`The accountability of everyone watching you means you won't just give up after three chapters. A fate too many of my early book attempts have endured.`}</li>
    </ol>
    <p>{`I also really like the book creation process.`}</p>
    <p>{`Writing happens in simple text files with markdown syntax. These are stored in a shared `}<a parentName="p" {...{
        "href": "http://www.dropbox.com",
        "title": "Dropbox"
      }}>{`Dropbox`}</a>{` folder so when you want to generate a new preview or publish a new version, Leanpub will simply sync the files from your computer and do its magic.`}</p>
    <p>{`They also have great customer service - the founder is always prompt to answer any questions on their mailing list - the writer dashboard is marvelous and they let you download any data in a csv format so you can do whatever analysis of sales you might want.`}</p>
    <p>{`Oh and coupon creation and so on ... they also handle all the mailing. Seriously, everything you need `}<em parentName="p">{`around`}</em>{` your book, so you can focus on the writing.`}</p>
    <p>{`The real killer feature is their TOS. Authors retain full copyright, there are no restrictions about using other publishers, no restrictions about selling the book without cutting Leanpub into the deal and so on. At 90%-50c the royalties are also very generous compared to more traditional publishers.`}</p>
    <p>{`Compare this with a traditional `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Publishing",
        "title": "Publishing"
      }}>{`publisher`}</a>{` contract I read last night; give away all copyright, both moral and practical, only allowed to quote your book according to fair use, must always mention publisher when talking about book, 16% royalties, indefinitely allow them the use of personal trademarks like my name for any purpose they deem fit, and not even a promise I would always be mentioned in relation with the book in question etc. etc. ...`}</p>
    <p>{`No no, `}<strong parentName="p"><em parentName="strong">{`Leanpub is`}</em></strong>{` `}<strong parentName="p"><em parentName="strong">{`universes ahead of traditional publishers.`}</em></strong></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blog.slideshare.net/2012/11/12/the-ebook-is-the-stud-in-your-content-marketing-stable/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_67_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blog.slideshare.net/2012/11/12/the-ebook-is-the-stud-in-your-content-marketing-stable/"
        }}>{`The eBook is the Stud in Your Content Marketing Stable`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-made-730-by-selling-an-unfinished-book-for-3-days/swizec/5585"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/126967527_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://swizec.com/blog/i-made-730-by-selling-an-unfinished-book-for-3-days/swizec/5585"
        }}>{`I made `}{`\\`}{`\\`}{`\\`}{`\\$730 by selling an unfinished book for 3 days.`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://michaeljholley.com/2012/11/21/what-to-watch-when-compiling-a-kindle-ebook-in-scrivener/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/127239456_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://michaeljholley.com/2012/11/21/what-to-watch-when-compiling-a-kindle-ebook-in-scrivener/"
        }}>{`What To Watch When Compiling A Kindle eBook in Scrivener`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://blaiselucey.com/2012/11/21/future-of-books/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/127242417_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://blaiselucey.com/2012/11/21/future-of-books/"
        }}>{`The Future of Books (Calm Down Edition)`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=6b78f839-a568-41f1-a4b4-173a47836a4f",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      